import { render, staticRenderFns } from "./PremiumWindow.vue?vue&type=template&id=0f4850ad&"
import script from "./PremiumWindow.vue?vue&type=script&lang=js&"
export * from "./PremiumWindow.vue?vue&type=script&lang=js&"
import style0 from "./PremiumWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports